import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b0366e0c"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0366e0c')) {
      api.createRecord('b0366e0c', component.options)
    } else {
      api.reload('b0366e0c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=b0366e0c", function () {
      api.rerender('b0366e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/modal-setting-date-publish/main.vue"
export default component.exports